import { useCallback } from "react";
import { apiRequest } from "./ApiRequest";

export const useApi = () => {
  const apiFetch = useCallback(
    async (script, data = {}, token = null) => {
      const result = await apiRequest({ script, data, token });
      return result;
    },
    []
  );

  return { apiFetch };
};
